/* OliWake — interaction layer.
   Drives the exact properties the original design animates:
   accordions = grid-template-rows 0fr<->1fr + visibility
   tabs       = opacity/transform on stacked <ul>s
   gallery    = translateX on absolutely-positioned slides
   No dependencies. */
(function () {
  'use strict';
  var OW = window.OW || {};
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ow = function (n, r) { return (r || document).querySelector('[data-ow="' + n + '"]'); };
  var owAll = function (n, r) { return $$('[data-ow="' + n + '"]', r); };
  var INK = 'rgb(20, 29, 43)', ONDARK = 'rgb(242, 238, 230)';
  var LINE = 'rgb(218, 212, 201)', AMBER_DEEP = 'rgb(180, 82, 12)';

  function money(cents) {
    var fmt = OW.moneyFormat || '${{amount}}';
    var amt = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amt);
  }

  /* ---------------- accordions ---------------- */
  function setPanel(panel, open) {
    if (!panel) return;
    panel.style.gridTemplateRows = open ? '1fr' : '0fr';
    panel.style.visibility = open ? 'visible' : 'hidden';
    panel.removeAttribute('hidden');           // never rely on [hidden]: inline display wins
  }
  $$('button[aria-controls][aria-expanded]').forEach(function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    setPanel(panel, open);
    var icon = btn.querySelector('svg');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var nowOpen = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(nowOpen));
      setPanel(panel, nowOpen);
      if (icon) icon.style.transform = nowOpen ? 'rotate(180deg)' : 'none';
    });
  });

  /* ---------------- tabs (stacked <ul>s) ---------------- */
  (function tabs() {
    var btns = $$('button[aria-controls]').filter(function (b) {
      return /^bl\d+$/.test(b.getAttribute('aria-controls') || '');
    });
    if (btns.length < 2) return;
    function select(active) {
      btns.forEach(function (b) {
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        var on = b === active;
        b.setAttribute('aria-pressed', String(on));
        b.style.background = on ? INK : 'transparent';
        b.style.color = on ? ONDARK : INK;
        b.style.borderColor = on ? INK : LINE;
        if (panel) {
          panel.style.opacity = on ? '1' : '0';
          panel.style.transform = on ? 'none' : 'translateY(8px)';
          panel.style.pointerEvents = on ? 'auto' : 'none';
          panel.setAttribute('aria-hidden', String(!on));
        }
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); select(b); });
    });
    var current = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0];
    select(current || btns[0]);
  })();

  /* ---------------- announcement rotator ---------------- */
  (function announce() {
    var prev = $('[aria-label="Previous announcement"]'), next = $('[aria-label="Next announcement"]');
    if (!prev || !next) return;
    var bar = prev.parentElement;
    var slides = $$('p,span', bar).filter(function (el) {
      return getComputedStyle(el).position === 'absolute' && el.textContent.trim();
    });
    if (slides.length < 2) return;
    var i = 0, t;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.style.opacity = k === i ? '1' : '0';
        s.style.transform = k === i ? 'none' : 'translateY(10px)';
        s.setAttribute('aria-hidden', String(k !== i));
      });
    }
    function auto() { clearInterval(t); t = setInterval(function () { show(i + 1); }, 5000); }
    prev.addEventListener('click', function (e) { e.preventDefault(); show(i - 1); auto(); });
    next.addEventListener('click', function (e) { e.preventDefault(); show(i + 1); auto(); });
    show(0); auto();
    bar.addEventListener('mouseenter', function () { clearInterval(t); });
    bar.addEventListener('mouseleave', auto);
  })();

  /* ---------------- mobile nav ---------------- */
  (function nav() {
    var drawer = document.getElementById('ow-drawer');
    var burger = ow('burger') || $('[aria-label="Open menu"]');
    var close = $('[aria-label="Close menu"]');
    if (!drawer) return;
    function set(open) {
      drawer.setAttribute('aria-hidden', String(!open));
      drawer.style.visibility = open ? 'visible' : 'hidden';
      drawer.style.transform = open ? 'none' : 'translateX(100%)';
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    if (burger) burger.addEventListener('click', function (e) { e.preventDefault(); set(true); });
    if (close) close.addEventListener('click', function (e) { e.preventDefault(); set(false); });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    set(false);
  })();

  /* ---------------- product gallery (crossfade) ---------------- */
  (function gallery() {
    var view = ow('gallery-view');
    if (!view) return;
    var track = view.querySelector(':scope > div');
    var slides = track ? $$(':scope > [role="img"]', track) : [];
    if (!slides.length && track) slides = $$(':scope > div', track);
    var thumbs = $$('button[aria-label^="Show image"]');
    if (!slides.length) return;
    function go(n) {
      slides.forEach(function (s, k) {
        s.style.opacity = k === n ? '1' : '0';
        s.style.transition = 'opacity .45s cubic-bezier(.2,.7,.2,1)';
        s.style.pointerEvents = k === n ? 'auto' : 'none';
        s.setAttribute('aria-hidden', String(k !== n));
      });
      thumbs.forEach(function (t, k) {
        t.setAttribute('aria-current', String(k === n));
        t.style.borderColor = k === n ? INK : LINE;
      });
      var c = ow('gallery-counter');
      if (c) c.textContent = (n + 1) + '/' + slides.length;
    }
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function (e) { e.preventDefault(); go(k); });
    });
    var start = slides.findIndex(function (s) { return getComputedStyle(s).opacity === '1'; });
    go(start < 0 ? 0 : start);
  })();

  /* ---------------- sticky buy bar ---------------- */
  (function sticky() {
    var bar = ow('stickybar'), anchor = ow('buy-col') || $('#ow-title');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('ow-show', !e.isIntersecting); });
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  })();

  /* ---------------- bundle / variant selection ---------------- */
  var radios = $$('input[name="ow-offer"]');
  function paintOffer() {
    radios.forEach(function (r) {
      var label = r.closest('label');
      if (!label) return;
      var on = r.checked;
      label.style.borderColor = on ? AMBER_DEEP : LINE;
      var ring = label.querySelector('span[aria-hidden="true"]');
      if (ring) ring.style.borderColor = on ? AMBER_DEEP : LINE;
      var dot = ring && ring.querySelector('span');
      if (dot) {
        dot.style.opacity = on ? '1' : '0';
        dot.style.transform = on ? 'none' : 'scale(0.4)';
      }
    });
    var checked = $('input[name="ow-offer"]:checked');
    var idx = checked ? parseInt(checked.value, 10) : 0;
    var v = (OW.variants || [])[idx];
    if (!v) return;
    owAll('atc-label').forEach(function (l) {
      if (l.getAttribute('data-ow-tpl') !== 'priced') return;
      l.textContent = 'Order yours — ' + money(v.price);
    });
  }
  owAll('atc-label').forEach(function (l) {
    l.setAttribute('data-ow-tpl', /\d/.test(l.textContent) ? 'priced' : 'plain');
  });
  radios.forEach(function (r) { r.addEventListener('change', paintOffer); });
  if (radios.length) paintOffer();

  function selectedVariantId() {
    var checked = $('input[name="ow-offer"]:checked');
    var idx = checked ? parseInt(checked.value, 10) : 0;
    var vs = OW.variants || [];
    var v = vs[idx] || vs[0];
    return v ? v.id : null;
  }

  /* ---------------- cart ---------------- */
  var cart = {
    el: function () { return document.getElementById('ow-cart'); },
    overlay: function () { return ow('cart-overlay'); },
    open: function () {
      var a = this.el(), o = this.overlay();
      if (!a) return;
      a.setAttribute('aria-hidden', 'false');
      a.style.visibility = 'visible'; a.style.transform = 'none';
      if (o) { o.hidden = false; requestAnimationFrame(function () { o.style.opacity = '1'; }); }
      document.documentElement.style.overflow = 'hidden';
    },
    close: function () {
      var a = this.el(), o = this.overlay();
      if (!a) return;
      a.setAttribute('aria-hidden', 'true');
      a.style.transform = 'translateX(100%)';
      setTimeout(function () { a.style.visibility = 'hidden'; }, 450);
      if (o) { o.style.opacity = '0'; setTimeout(function () { o.hidden = true; }, 380); }
      document.documentElement.style.overflow = '';
    },
    render: function (d) {
      var items = ow('cart-items'), empty = ow('cart-empty'),
          foot = ow('cart-foot'), sub = ow('cart-subtotal');
      var count = d.item_count || 0;
      var btn = $('[aria-label^="Cart,"]');
      if (btn) btn.setAttribute('aria-label', 'Cart, ' + count + ' item' + (count === 1 ? '' : 's'));
      if (!items) return;
      if (!count) {
        items.hidden = true; if (empty) empty.hidden = false; if (foot) foot.hidden = true; return;
      }
      if (empty) empty.hidden = true;
      items.hidden = false; if (foot) foot.hidden = false;
      if (sub) sub.textContent = money(d.total_price);
      items.innerHTML = d.items.map(function (it) {
        return '<li style="display:flex;gap:12px;align-items:flex-start">' +
          (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') +
            '" alt="" width="64" height="64" style="border-radius:10px;background:#EFEBE4;object-fit:cover">' : '') +
          '<div style="flex:1;min-width:0">' +
            '<p style="margin:0;font-weight:600;font-size:14.5px">' + it.product_title + '</p>' +
            '<p style="margin:2px 0 6px;font-size:13px;color:#5F5A51">' +
              (it.variant_title ? it.variant_title + ' &middot; ' : '') + 'Qty ' + it.quantity + '</p>' +
            '<button type="button" data-ow="cart-remove" data-key="' + it.key + '" ' +
              'style="border:0;background:none;padding:0;font-size:12.5px;color:#5F5A51;' +
              'text-decoration:underline;cursor:pointer">Remove</button>' +
          '</div><strong style="font-size:14.5px">' + money(it.final_line_price) + '</strong></li>';
      }).join('');
    },
    fetch: function () {
      var s = this;
      return fetch(OW.routes.cart, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { s.render(d); return d; }).catch(function () {});
    },
    add: function (id, qty) {
      var s = this;
      return fetch(OW.routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); });
        return r.json();
      }).then(function () { return s.fetch(); }).then(function () { s.open(); });
    },
    remove: function (key) {
      var s = this;
      return fetch(OW.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (d) { s.render(d); });
    }
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ow="cart-close"]')) { e.preventDefault(); cart.close(); return; }
    if (e.target.closest('[data-ow="cart-overlay"]')) { cart.close(); return; }
    if (e.target.closest('[aria-label^="Cart,"]')) { e.preventDefault(); cart.open(); cart.fetch(); return; }
    var rm = e.target.closest('[data-ow="cart-remove"]');
    if (rm) { e.preventDefault(); cart.remove(rm.getAttribute('data-key')); return; }

    var atc = e.target.closest('[data-ow="atc"]');
    if (!atc) return;
    e.preventDefault();
    var id = selectedVariantId();
    if (!id) {                       // product/handle not configured in theme settings
      console.warn('[OliWake] No product variants found. Set Theme settings > Store > Product handle.');
      alert('This store is still being set up — the product isn\u2019t connected yet.');
      return;
    }
    var label = atc.querySelector('[data-ow="atc-label"]') || atc;
    var original = label.textContent;
    atc.disabled = true; label.textContent = 'Adding…';
    cart.add(id, 1).then(function () {
      label.textContent = 'Added ✓';
      setTimeout(function () { label.textContent = original; atc.disabled = false; }, 1600);
    }).catch(function (err) {
      label.textContent = original; atc.disabled = false;
      alert(err.message || 'Sorry — that could not be added.');
    });
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cart.close(); });
  if (OW.routes && OW.routes.cart) cart.fetch();

  /* ---------------- email signup ---------------- */
  (function email() {
    var input = document.getElementById('ow-email');
    var form = input ? input.closest('form') : $('form[novalidate]');
    if (!form) return;
    form.setAttribute('action', '/contact#contact_form');
    form.setAttribute('method', 'post');
    form.setAttribute('accept-charset', 'UTF-8');
    if (!form.querySelector('input[name="form_type"]')) {
      form.insertAdjacentHTML('afterbegin',
        '<input type="hidden" name="form_type" value="customer">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="newsletter">');
    }
    if (input) { input.name = 'contact[email]'; input.type = 'email'; input.required = true; }
  })();
})();
